import _get from 'lodash/get';
import {
  AiUsageByUser,
  AiUsageByUserQueryVariables,
  useAiUsageByUserQuery,
} from 'graphql-common';
import { GetUrlParams } from '@lib/enums/urls';
import getAiUsageSorts from 'routes/CompanyPlan/utils/getAiUsageSorts';
import { ListQueryHookProps } from '../types';

export default function useAiUsageByUserQueryHook({
  fetchPolicy = 'cache-and-network',
  orderingParams,
  paginationParams,
  searchQuery,
  skip,
}: ListQueryHookProps) {
  const page = _get(paginationParams, GetUrlParams.Page);
  const perPage = _get(paginationParams, GetUrlParams.PerPage);
  const queryVariables: AiUsageByUserQueryVariables = {
    page: Number(page),
    limit: Number(perPage),
    sorts: getAiUsageSorts(orderingParams || {}),
  };
  if (searchQuery) {
    queryVariables.filters = [
      { fullName: { predicate: { iCont: searchQuery } } },
    ];
  }
  const query = useAiUsageByUserQuery({
    fetchPolicy,
    variables: queryVariables,
    skip,
  });
  const { loading, data, previousData, refetch, error } = query;
  const queryData = data || previousData;
  const firstLoading = loading && previousData === undefined;
  const collection = _get(queryData, 'data.collection', []) as AiUsageByUser[];
  const metadata = _get(queryData, 'data.metadata');
  const totalCount = _get(metadata, 'totalCount', 0);
  const totalPages = _get(metadata, 'totalPages', 1);

  return {
    collection,
    error,
    firstLoading,
    loading,
    refetch,
    totalCount,
    totalPages,
  };
}
